// =========================================================
// * Vuetify Material Dashboard - v2.1.0
// =========================================================
//
// * Product Page: https://www.creative-tim.com/product/vuetify-material-dashboard
// * Copyright 2019 Creative Tim (https://www.creative-tim.com)
//
// * Coded by Creative Tim
//
// =========================================================
//
// * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'
import './plugins/base'
import './plugins/chartist'
import './plugins/vee-validate'
import vuetify from './plugins/vuetify'
import i18n from './i18n'
import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/analytics'
import VueHead from 'vue-head'
import { firestorePlugin } from 'vuefire'
Vue.use(firestorePlugin)

Vue.config.productionTip = false

var firebaseConfig = {
  apiKey: 'AIzaSyA86t_ZtANWzpMtEH6ZLKD5-8-XTpF1FGE',
  authDomain: 'document-checker-project.firebaseapp.com',
  databaseURL: 'https://document-checker-project.firebaseio.com',
  projectId: 'document-checker-project',
  storageBucket: 'document-checker-project.appspot.com',
  messagingSenderId: '691979779815',
  appId: '1:691979779815:web:b1944babf87638cf146c42',
  measurementId: 'G-9L8ZDJ206S',
}
// Initialize Firebase
firebase.initializeApp(firebaseConfig)
firebase.analytics()
export const db = firebase.firestore()

Vue.use(VueHead, {
  separator: ' | ',
})

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App),
}).$mount('#app')
